export default __webpack_public_path__ + "f82102b50b451b4349a616168ce9e60e.png";